import { useDecisionTreeStore } from '../dal/decision-tree-store';
import { ChangeEvent } from 'react';
import { DecisionTree } from '../domain/tree/decision-tree';
import { DecisionTreeTable } from '../domain/table/decision-tree-table';
import { setIncludeCalculationsToStorage } from '../dal/decision-tree-storage';

const TopPanel = () => {

    const setIncludeCalculations = useDecisionTreeStore(store => store.setIncludeCalculations);
    const setDecisionTree = useDecisionTreeStore(store => store.setDecisionTree);
    const csv = useDecisionTreeStore(store => store.csv);
    const setCsv = useDecisionTreeStore(store => store.setCsv);
    const columnsRewrittenTypes = useDecisionTreeStore(store => store.columnsRewrittenTypes);
    const forceBinningColumns = useDecisionTreeStore(store => store.forceBinningColumns);
    const setDecisionTreeTable = useDecisionTreeStore(store => store.setDecisionTreeTable);
    const excludedColumns = useDecisionTreeStore(store => store.excludedColumns);
    const includeCalculations = useDecisionTreeStore(store => store.includeCalculations);
    const binningByDepth = useDecisionTreeStore(store => store.binningByDepth);
    const binningGroupsCount = useDecisionTreeStore(store => store.binningGroupsCount);
    
    const onClick = () => {

        if(csv.trim() === '') {
            setDecisionTreeTable(null);
            setDecisionTree(null);
        }
        else{
            setDecisionTreeTable(new DecisionTreeTable(
                csv,
                excludedColumns,
                forceBinningColumns,
                columnsRewrittenTypes,
                binningByDepth,
                binningGroupsCount
            ));

            setDecisionTree(new DecisionTree(
                csv,
                excludedColumns,
                forceBinningColumns,
                columnsRewrittenTypes,
                binningByDepth,
                binningGroupsCount
            ));
        }

        setCsv(csv.trim().replaceAll('', 'נ'));
    };

    const onIncludeCalculationsChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const isChecked = !(evt.target.checked);
        setIncludeCalculations(isChecked);
        setIncludeCalculationsToStorage(isChecked);
    };

    return (
        <div className="flex items-center w-full mb-4" dir="ltr">
            <h1 className="text-2xl px-4">Decision Tree</h1>

            <button
                type="button"
                onClick={ onClick }
                className="px-6 bg-sky-100 rounded mx-6 border border-sky-300">
                Update
            </button>

            <label className="text-sm">
                <input
                    checked={ includeCalculations }
                    type="checkbox"
                    onInput={ onIncludeCalculationsChange }
                    className="mx-2"
                />
                <span>Include Calculations</span>
            </label>

        </div>
    )
};

export default TopPanel;